import axios, { AxiosResponse } from 'axios';
import { SendRequestConfig } from '../models/sendRequest.model';
import { UploadFile } from '../models/uploadFiles.model';
import ApplicationDetail from './applicationDetail.service';
import { errorHandler } from './errorHandler.service';
import { shouldSetProviderDataFromLocalStorage } from './../../utils/routeUtility';
import {decryptText} from '../../utils/encryptDecrypt';
import { encryptData } from '../../utils/encryptDecryptUtility';
import _ from 'lodash';

const defualtConfig: SendRequestConfig = {
  isShowErrorInInterceptor: { isShowErrorInModal: false },
};

class SendRequest {
  private static _instance: SendRequest = new SendRequest();
  private appDetail: ApplicationDetail = ApplicationDetail.instance;

  constructor() {
    if (SendRequest._instance) {
      throw new Error('Use DataService.instance');
    }
    SendRequest._instance = this;
  }

  static get instance(): SendRequest {
    return SendRequest._instance;
  }

  get<R>(
    url: string,
    sendRequestConfig: SendRequestConfig = defualtConfig,
    { headers, isShowErrorInInterceptor }: SendRequestConfig = {
      ...defualtConfig,
      ...sendRequestConfig,
    },
  ): Promise<any> {
    const reqOption = {
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
      withCredentials: true,
    };
    return axios(url, reqOption).catch((error: Error): void => {
      errorHandler(error, isShowErrorInInterceptor);
    });
  }

  postBenef<T, R>(
    url: string,
    body: T,
    sendRequestConfig: SendRequestConfig = defualtConfig,
    { headers, isShowErrorInInterceptor }: SendRequestConfig = { ...defualtConfig, ...sendRequestConfig },
    isProviderInfoRequired: boolean = true,
    isBenef: boolean = true,

  ): Promise<any> {
    const {
      responseType = '',
    } = sendRequestConfig;
    if (isProviderInfoRequired) {
      let providerId;
      let providerName;
      let rohiniCode;
      if (
        this.appDetail.getProviderId() &&
        !shouldSetProviderDataFromLocalStorage(url)
      ) {
        providerId = this.appDetail.getProviderId();
        providerName = this.appDetail.getProviderName();
        rohiniCode = this.appDetail.getRohiniCode();
      } else {
        let providerDetail: any = decryptText(localStorage.getItem('providerDetail') || '{}');
        providerDetail = providerDetail ? JSON.parse(providerDetail) : {};
        providerId = providerDetail?.providerId;
        providerName = providerDetail?.providerName;
        rohiniCode = providerDetail?.providerRohiniCode;
      }
      body = {
        ...body,
        providerId, providerName, rohiniCode,
      };
    }
    headers = {
      'Content-Type': 'application/json',
      client_key: encryptData(`platform-ui|${_.now()}`),
      ...headers,
    };

    let additionalData: any = {};
    if (responseType) {
      additionalData = {
        ...additionalData,
        responseType,
      };
    }

    return axios
      .post(url, JSON.stringify(body), { withCredentials: true, headers, ...additionalData })
      .catch((error: Error): void => {
        errorHandler(error, isShowErrorInInterceptor, undefined, isBenef);
      });
  }
  postHomepage<T, R>(
    url: string,
    body: T,
    sendRequestConfig: SendRequestConfig = defualtConfig,
    { headers, isShowErrorInInterceptor }: SendRequestConfig = { ...defualtConfig, ...sendRequestConfig },
    isProviderInfoRequired: boolean = true,
    isBadRequest: boolean = true,

  ): Promise<any> {
    const {
      responseType = '',
    } = sendRequestConfig;
    if (isProviderInfoRequired) {
      let providerId;
      let providerName;
      let rohiniCode;
      if (
        this.appDetail.getProviderId() &&
        !shouldSetProviderDataFromLocalStorage(url)
      ) {
        providerId = this.appDetail.getProviderId();
        providerName = this.appDetail.getProviderName();
        rohiniCode = this.appDetail.getRohiniCode();
      } else {
        let providerDetail: any = decryptText(localStorage.getItem('providerDetail') || '{}');
        providerDetail = providerDetail ? JSON.parse(providerDetail) : {};
        providerId = providerDetail?.providerId;
        providerName = providerDetail?.providerName;
        rohiniCode = providerDetail?.providerRohiniCode;
      }
      body = {
        ...body,
        providerId, providerName, rohiniCode,
      };
    }
    headers = {
      'Content-Type': 'application/json',
      client_key: encryptData(`platform-ui|${_.now()}`),
      ...headers,
    };

    let additionalData: any = {};
    if (responseType) {
      additionalData = {
        ...additionalData,
        responseType,
      };
    }

    return axios
      .post(url, JSON.stringify(body), { withCredentials: true, headers, ...additionalData })
      .catch((error: Error): void => {
        errorHandler(error, isShowErrorInInterceptor, undefined, isBadRequest);
      });
  }
  post<T, R>(
    url: string,
    body: T,
    sendRequestConfig: SendRequestConfig = defualtConfig,
    { headers, isShowErrorInInterceptor }: SendRequestConfig = { ...defualtConfig, ...sendRequestConfig },
    isProviderInfoRequired: boolean = true,
    isBadRequest: boolean = true,
    showProviderId?: boolean | undefined,
  ): Promise<any> {
    const {
      responseType = '',
    } = sendRequestConfig;
    if (!showProviderId && isProviderInfoRequired) {
      let providerId;
      let providerName;
      let rohiniCode;
      if (
        this.appDetail.getProviderId() &&
        !shouldSetProviderDataFromLocalStorage(url)
      ) {
        providerId = this.appDetail.getProviderId();
        providerName = this.appDetail.getProviderName();
        rohiniCode = this.appDetail.getRohiniCode();
      } else {
        let providerDetail: any = decryptText(localStorage.getItem('providerDetail') || '{}');
        providerDetail = providerDetail ? JSON.parse(providerDetail) : {};
        providerId = providerDetail?.providerId;
        providerName = providerDetail?.providerName;
        rohiniCode = providerDetail?.providerRohiniCode;
      }
      body = {
        ...body,
        providerId,
        providerName,
        rohiniCode,
      };
    } else if (showProviderId) {
      let providerDetail: any = decryptText(localStorage.getItem('providerDetail') || '{}');
      providerDetail = providerDetail ? JSON?.parse?.(providerDetail) : {};
      const providerNameData = providerDetail?.providerName;
      const rohiniCodeData = providerDetail?.providerRohiniCode;
      const hipIdData = providerDetail?.hip_Hiu_Id?.id;
      const providerID = body?.['providerId'];
      body = {
        ...body,
        providerId: providerID,
        providerName: providerNameData,
        rohiniCode: rohiniCodeData,
        hipId: hipIdData,
      };
    }

    headers = {
      'Content-Type': 'application/json',
      client_key: encryptData(`platform-ui|${_.now()}`),
      ...headers,
    };

    let additionalData: any = {};
    if (responseType) {
      additionalData = {
        withCredentials: true,
        ...additionalData,
        responseType,
      };
    }

    return axios
      .post(url, JSON.stringify(body), { withCredentials: true, headers, ...additionalData })
      .catch((error: Error): void => {
        errorHandler(error, isShowErrorInInterceptor, undefined, isBadRequest);
      });
  }

  all<R>(
    xhrArray: (AxiosResponse<R> | Promise<AxiosResponse<R>>)[],
  ): Promise<AxiosResponse<R>[]> {
    return axios.all(xhrArray);
  }

  postFormData(
    url: string,
    reqObject: any,
    files: File | File[] = [],
    defaultFormData: FormData = new FormData(),
    sendRequestConfig: SendRequestConfig = defualtConfig,
    { headers, isShowErrorInInterceptor }: SendRequestConfig = { ...defualtConfig, ...sendRequestConfig },
    isBadRequest: boolean = true,
  ): Promise<any> {

    const formData = defaultFormData;
    if (Object.keys(reqObject)?.length) {
      Object.keys(reqObject)?.forEach((key: string): any => {
        formData.append(key, reqObject[key]);
      });
    }
    if (files && files instanceof File) {
      formData.append('file', files);
    } else {
      files?.forEach((file: File): void =>
        formData.append('file', file),
      );
      formData.append('FileUploadType', 'Report');
      formData.append('ApplicationId', '9214');
    }

    return axios({
      url,
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        ...headers,
      },
      withCredentials : true,
    }).catch((error: Error): any =>
      errorHandler(error, isShowErrorInInterceptor, files , isBadRequest),
    );
  }

  upload(
    url: string,
    files: File | File[],
    defaultFormData: FormData = new FormData(),
    sendRequestConfig: SendRequestConfig = defualtConfig,
    { headers, isShowErrorInInterceptor }: SendRequestConfig = { ...defualtConfig, ...sendRequestConfig },
    isBadRequest: boolean = true,
  ): Promise<UploadFile> {

    const formData = defaultFormData;
    if (files && files instanceof File) {
      formData.append('file', files);
    } else {
      files.forEach((file: File): void =>
        formData.append('file', file),
      );

      formData.append('FileUploadType', localStorage?.getItem('FileUploadType') || 'Report');
      formData.append('ApplicationId', '9214');
    }

    return axios({
      url,
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        ...headers,
      },
      withCredentials : true,
    }).catch((error: Error): any =>
      errorHandler(error, isShowErrorInInterceptor, files, isBadRequest),
    );
  }

  uploadAll(
    url: string,
    files: File[],
    sendRequestConfig: SendRequestConfig = defualtConfig,
    isBadRequest: boolean = true,
    { isShowErrorInInterceptor }: SendRequestConfig = {
      ...defualtConfig,
      ...sendRequestConfig,
    },
  ): Promise<AxiosResponse<UploadFile[]>[]> {
    const fileXhr = files.map((file: File): Promise<UploadFile> =>
      this.upload(url, file, new FormData(), sendRequestConfig));
    return axios.all(fileXhr)
      .catch((error: Error): any =>
        errorHandler(error, isShowErrorInInterceptor, undefined, isBadRequest),
      );
  }
}
export default SendRequest;
